import { useContext } from 'react'
import { TokenBalanceContext } from '../providers/BalanceProvider'

export default function useBalances() {
  return useContext(TokenBalanceContext)
}
